// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__NvXqt","modal-show":"Modal_modal-show__WSwY5","openModal":"Modal_openModal__jI1W4","modal-bg-show":"Modal_modal-bg-show__JgRlR"};